// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#default-loan-data {
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  #default-loan-data {
    height: auto;
  }
}
@media (max-width: 768px) {
  #default-loan-data .contracts-area {
    margin-bottom: 2rem;
  }
}
#default-loan-data .users-data {
  padding: 2.5rem 0;
  border-bottom: 0.063rem solid #C9D3CC;
}
@media (max-width: 768px) {
  #default-loan-data .users-data {
    padding-bottom: 0rem;
  }
}
#default-loan-data .users-data .loan-data-users-status {
  margin-top: 2.25rem;
}
@media (max-width: 768px) {
  #default-loan-data .users-data .loan-data-users-status {
    margin-top: 0rem;
  }
}
#default-loan-data .users-data .loan-data-users {
  margin-bottom: 1.5rem;
}
#default-loan-data .gyramais-information .interest-rate-tooltip {
  margin-left: 0.5rem;
}
#default-loan-data .loan-data {
  padding: 2.5rem 0;
  border-bottom: 0.063rem solid #C9D3CC;
}
@media (max-width: 768px) {
  #default-loan-data .loan-data {
    padding-bottom: 1rem;
  }
}
#default-loan-data .loan-data .ant-row {
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  #default-loan-data .loan-data .ant-row {
    margin-bottom: 0rem;
  }
}
#default-loan-data .loan-data-checkbox {
  padding-top: 3.5rem;
  flex-grow: 1;
}
@media (max-width: 768px) {
  #default-loan-data .loan-data-checkbox {
    padding-top: 2.25rem;
    margin-bottom: 1rem !important;
  }
}
#default-loan-data .loan-data-footer {
  border-top: 0.063rem solid #C9D3CC;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 1.25rem 3.75rem;
}
#default-loan-data .view-contract-btn {
  margin-left: auto;
}
@media (max-width: 768px) {
  #default-loan-data .view-contract-btn {
    margin: auto;
  }
}
@media (max-width: 768px) {
  #default-loan-data .code-row {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/others/LoanData/components/DefaultLoanData/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EAAA;IACE,YAAA;EAEF;AACF;AACI;EAAA;IACE,mBAAA;EAEJ;AACF;AAbA;EAeI,iBAAA;EACA,qCAAA;AACJ;AACI;EAAA;IACE,oBAAA;EAEJ;AACF;AAtBA;EAuBM,mBAAA;AAEN;AAAM;EAAA;IACE,gBAAA;EAGN;AACF;AA9BA;EA+BM,qBAAA;AAEN;AAjCA;EAqCM,mBAAA;AADN;AApCA;EA0CI,iBAAA;EACA,qCAAA;AAHJ;AAKI;EAAA;IACE,oBAAA;EAFJ;AACF;AA7CA;EAkDM,qBAAA;AAFN;AAIM;EAAA;IACE,mBAAA;EADN;AACF;AArDA;EA2DI,mBAAA;EACA,YAAA;AAHJ;AAKI;EAAA;IACE,oBAAA;IACA,8BAAA;EAFJ;AACF;AA/DA;EAqEI,kCAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;AAHJ;AAtEA;EA6EI,iBAAA;AAJJ;AAMI;EAAA;IACE,YAAA;EAHJ;AACF;AAOE;EAAA;IAEI,uBAAA;EALJ;AACF","sourcesContent":["#default-loan-data{\n  display: flex;\n  flex-direction: column;\n\n  @media(max-width: @md-screen) {\n    height: auto;\n  }\n\n  .contracts-area {\n    @media(max-width: @md-screen) {\n      margin-bottom: 2rem;\n    }\n  }\n\n  .users-data {\n    padding: 2.5rem 0;\n    border-bottom: .063rem solid #C9D3CC;\n\n    @media(max-width: @md-screen) {\n      padding-bottom: 0rem;\n    }\n\n    .loan-data-users-status{\n      margin-top: 2.25rem;\n\n      @media(max-width: @md-screen) {\n        margin-top: 0rem;\n      }\n    }\n\n    .loan-data-users {\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  .gyramais-information {\n    .interest-rate-tooltip{\n      margin-left: 0.5rem;\n    }\n  }\n\n  .loan-data{\n    padding: 2.5rem 0;\n    border-bottom: .063rem solid #C9D3CC;\n\n    @media(max-width: @md-screen) {\n      padding-bottom: 1rem;\n    }\n\n    .ant-row {\n      margin-bottom: 1.5rem;\n      \n      @media(max-width: @md-screen) {\n        margin-bottom: 0rem;\n      }  \n    }\n  }\n\n  .loan-data-checkbox {\n    padding-top: 3.5rem;\n    flex-grow: 1;\n\n    @media(max-width: @md-screen) {\n      padding-top: 2.25rem;\n      margin-bottom: 1rem !important;\n    }\n  }\n  \n  .loan-data-footer{\n    border-top: .063rem solid #C9D3CC;\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    padding: 1.25rem 3.75rem;\n  }\n\n  .view-contract-btn {\n    margin-left: auto;\n\n    @media(max-width: @md-screen) {\n      margin: auto;\n    }\n  }\n  \n  \n  @media(max-width: @md-screen) {\n    .code-row {\n      justify-content: center;\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
